export { default as DuplicatePencilSolidIcon } from './DuplicatePencilSolidIcon';
